<!--兑换记录-->
<template>
  <div class="qmyx-container">
    <div class="body">
      <div class="header">
        {{ "累计已兑换：" + coinTotal + "优币" }}
      </div>
      <div
        class="body-list"
        v-for="(item, index) in recordsList"
        v-bind:key="index"
      >
        <div class="body-list-left">
          <div class="body-list-left-total">{{ item.toTel }}</div>
          <div class="body-list-left-date">
            {{ item.exchangeDate }}
          </div>
        </div>
        <div class="body-list-right">
          <span class="body-list-right-number">{{ item.uCurrency * 100 }}</span>
          <img
            class="body-list-right-img"
            src="https://assets.rurushishi.com/yq-rs-make/huafa/img/duihuanjl_ic_duihuan.png"
          />
          <span class="body-list-right-coin">{{
            item.uCurrency + "优币"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAgent } from "@/views/qmyx/api";
import { getExchangeRecords } from "./api";
export default {
  data() {
    return {
      recordsList: []
    };
  },
  activated() {
    this.getRecordsList();
  },
  computed: {
    coinTotal() {
      let list = this.recordsList;
      let coin = 0;
      for (var i = 0; i < list.length; i++) {
        coin += Number(list[i].uCurrency);
      }
      return coin;
    }
  },
  methods: {
    async getRecordsList() {
      let res = await getAgent();
      const { agentLogin: { id = "" } = {} } = res;
      let params = { agentId: id };
      const { data } = await getExchangeRecords(params);
      this.recordsList = data;
    }
  }
};
</script>
<style>
.header {
  padding: 20px 0 15px 0;
}
.body {
  padding: 0 16px 0 16px;
}
.body-list {
  padding: 17px 0 15px 0;
  border-bottom: 1px solid rgba(244, 244, 244, 1);
}
.body-list-left {
  display: inline-block;
}
.body-list-right {
  display: inline-block;
  float: right;
  margin-top: 8px;
  height: 100%;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.body-list-right-number {
  color: rgba(240, 123, 36, 1);
}
.body-list-right-coin {
  font-weight: 800;
}
.body-list-right-img {
  margin: 0 5px 0 9px;
  height: 12px;
}
.body-list-left-total {
  font-size: 14px;
  font-weight: 400;
}
.body-list-left-date {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 450;
  color: rgba(153, 153, 153, 1);
  margin-top: 7px;
}
</style>
